import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { Button } from 'components';

import classNames from 'classnames/bind';
import styles from './DetailTemplate.css';
const cx = classNames.bind(styles);

// 상세 view 에서 공통으로 사용하는 템플릿
class DetailTemplate extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { children, btDatas, onMoveScroll, onToggleDetailView } = this.props;
    return (
      <div className={cx('detail-wrapper')}>
        {/* <Button
          className={cx('bt-closeDetail')}
          icon
          title={defineMessages(formatMessage({ id: 'DetailTemplate_1', defaultMessage: '상세 닫기' }))}
          onClick={onToggleDetailView}>
          <Icon name="cancel" />
        </Button> */}
        {/* <div className={cx('detail-button')}>
          {btDatas.map((btData, i) => {
            return (
              !!btData.isView && (
                <Tooltip key={i} title={btData.content} placement="right">
                  <a
                    className="bt-moveIcon"
                    onClick={() => {
                      onMoveScroll(btData.id);
                    }}>
                    <Icon size="large" name={btData.iconName} />
                  </a>
                </Tooltip>
              )
            );
          })}
        </div> */}
        <div className={cx('detail-content')}>{children}</div>
      </div>
    );
  }
}

export default injectIntl(DetailTemplate);



// WEBPACK FOOTER //
// ./src/script/components/template/DetailTemplate.js